import { ApiProperty } from "@nestjs/swagger";

export class RackReserveRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    zoneId:number;
    @ApiProperty()
    rackId:number;
}
